import { FormVmItemConfigType } from '../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../infrastructure/utils/form-config.utils';
import { trimSpaces, trimSpacesLeft } from '../../../../../../modules/formatters';
import { emailList, plainText, richText } from '../../../../../../modules/validators';
import { EMAIL_BODY_TEXT, EMAIL_SUBJECT_TEXT } from '../../../_edit-website/website-form-body/scheduled-emails-form/scheduled-email-form/scheduled-email-form.texts';
import { BCC_TEXT, CC_TEXT, REPLY_TO_TEXT, TO_TEXT } from './send-connections-email-form.texts';

export enum FieldKey {
    TO = 'to',
    REPLY_TO = 'replyTo',
    CC = 'cc',
    BCC = 'bcc',
    EMAIL_SUBJECT = 'emailSubject',
    EMAIL_BODY = 'emailBody'
}

export const FORM_CONFIG = {
    [FieldKey.TO]: {
        labelDescriptor: TO_TEXT,
        defaultValue: [],
        validators: [plainText.required, emailList.regExp],
        formatters: [trimSpaces]
    },
    [FieldKey.REPLY_TO]: {
        labelDescriptor: REPLY_TO_TEXT,
        defaultValue: [],
        validators: [emailList.regExp],
        formatters: [trimSpaces]
    },
    [FieldKey.CC]: {
        labelDescriptor: CC_TEXT,
        defaultValue: [],
        validators: [emailList.regExp],
        formatters: [trimSpaces]
    },
    [FieldKey.BCC]: {
        labelDescriptor: BCC_TEXT,
        defaultValue: [],
        validators: [emailList.regExp],
        formatters: [trimSpaces]
    },
    [FieldKey.EMAIL_SUBJECT]: {
        labelDescriptor: EMAIL_SUBJECT_TEXT,
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [FieldKey.EMAIL_BODY]: {
        labelDescriptor: EMAIL_BODY_TEXT,
        defaultValue: '',
        validators: [plainText.required, richText.maxLength.long],
        formatters: [trimSpacesLeft]
    },
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
